import React from "react";
import "./floatingButtons.css";

function FloatingButtons() {
    // Botón de volver arriba
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div>         

            {/* Botón de volver arriba (abajo a la derecha) */}
            <button className="scroll-to-top" onClick={scrollToTop} aria-label="Volver arriba">
                ↑
            </button>
        </div>
    );
}

export default FloatingButtons;
